// Heavy sections stay as native <details> in SSR. This island is reserved
// for progressive enhancement (SPEC-03) and must not hide content.
export default function DetailTabs({ children }) {
  return children || null;
}
